import { render } from "./SVGGradient.vue?vue&type=template&id=b261e890"
const script = {}
script.render = render

export default script